// config/handsontable.ts
import { parse, isValid } from 'date-fns';
import Handsontable from 'handsontable';
import { TABLE_HEIGHT, MIN_SPARE_ROWS } from './constants';

// Custom ISO Date Editor
export class ISODateEditor extends Handsontable.editors.DateEditor {
  getValue() {
    const dateValue = super.getValue();

    if (!dateValue || dateValue === '') {
      return null;
    }

    if (dateValue instanceof Date) {
      if (isNaN(dateValue.getTime())) {
        console.warn('Invalid Date object:', dateValue);
        return null;
      }
      return dateValue.toISOString();
    }

    if (typeof dateValue === 'string') {
      let parsedDate = parse(dateValue, 'dd/MM/yyyy', new Date());
      if (isValid(parsedDate)) {
        return parsedDate.toISOString();
      }

      parsedDate = parse(dateValue, 'yyyy-MM-dd', new Date());
      if (isValid(parsedDate)) {
        return parsedDate.toISOString();
      }

      parsedDate = new Date(dateValue);
      if (isValid(parsedDate)) {
        return parsedDate.toISOString();
      }

      console.warn('Could not parse date string:', dateValue);
      return null;
    }

    console.warn('Unexpected date value type:', typeof dateValue, dateValue);
    return null;
  }

  setValue(newValue: string) {
    if (!newValue) {
      super.setValue('');
      return;
    }

    if (newValue && newValue.includes('T')) {
      const dateOnly = newValue.split('T')[0];
      super.setValue(dateOnly);
      return;
    }

    super.setValue(newValue);
  }
}

// Register custom elements
export function registerCustomElements() {
  Handsontable.editors.registerEditor('iso-date', ISODateEditor);
}

// Base table settings
export function getBaseTableSettings() {
  return {
    rowHeaders: true,
    colHeaders: true,
    height: TABLE_HEIGHT,
    width: '100%',
    stretchH: 'all',
    manualColumnResize: true,
    themeName: 'ht-theme-main',
    search: true,
    className: 'htCenter htMiddle',
    licenseKey: 'non-commercial-and-evaluation',
    minSpareRows: MIN_SPARE_ROWS,
    hiddenColumns: {
      indicators: true,
    },
    autoWrapRow: false,
    wordWrap: false,
  } as const;
}
